/* hd-rangeguard.js —— 设计台滑杆防误触守卫
   2026-09-20 用户要求（第二版）：**允许「按住横向拖动」，无论起点在旋钮还是滑轨**；
   但「轻点滑轨」不生效、「纵向滑动（滚页面）经过滑杆」也不改值。

   判据 = 位移方向（不再要求点中旋钮）：
     · 横向位移 ≥6px 且大于纵向 ⇒ 认定「拖动」⇒ 放行（原生拖动，值正常跟随）
     · 尚未确认拖动（轻点 / 纵向滑动）⇒ 拦下本次数值变化并弹回原值，且不让副作用执行
   不碰 CSS、不让事件穿透（避免触摸穿透到抽屉背景、误触「点空白收起抽屉」）。
   幂等：window.__hdRangeGuard。
*/
(function () {
  if (window.__hdRangeGuard) return;
  window.__hdRangeGuard = true;

  var TH_H = 6;        /* 横向位移阈值（px）：达到即认定「拖动」 */
  var TH_V = 8;        /* 纵向位移阈值（px）：仅用于记录方向 */
  var MAX = 6000;      /* 兜底：手势异常未抬起时 6s 自动解除 */
  var st = null;

  function isRange(el) {
    return !!(el && el.tagName === 'INPUT' && (el.type === 'range' || el.getAttribute('type') === 'range'));
  }
  function inDesigner(el) {
    try { return !!(el.closest && (el.closest('#pfmBoard') || el.closest('#pfmDrawBox'))); } catch (e) { return false; }
  }
  function revert() {
    var s = st; if (!s) return;
    setTimeout(function () {
      try { if (String(s.el.value) !== String(s.v0)) s.el.value = s.v0; } catch (x) { }
    }, 0);
  }

  function onDown(e) {
    var el = e.target;
    if (!isRange(el) || !inDesigner(el)) return;
    st = { el: el, v0: parseFloat(el.value), x0: e.clientX, y0: e.clientY, h: false, v: false, t: Date.now() };
  }
  function onMove(e) {
    if (!st) return;
    if (Date.now() - st.t > MAX) { st = null; return; }
    var dx = Math.abs(e.clientX - st.x0), dy = Math.abs(e.clientY - st.y0);
    if (dx >= TH_H && dx > dy) st.h = true;      /* 横向拖动 ⇒ 放行 */
    if (dy >= TH_V && dy > dx) st.v = true;      /* 纵向滑动 ⇒ 记方向（仍算「未确认拖动」） */
  }
  function onValue(e) {
    if (!st || e.target !== st.el) return;
    if (Date.now() - st.t > MAX) { st = null; return; }
    if (st.h) return;                            /* 已确认拖动 ⇒ 放行 */
    /* 未确认拖动（轻点 / 纵向滑动）⇒ 拦下数值变化，且不让任何监听器看到（副作用零执行） */
    try { e.stopImmediatePropagation(); } catch (x) { }
    revert();
  }
  function onUp() {
    var s = st; if (!s) return;
    setTimeout(function () {
      /* 兜底：整段手势没形成横向拖动 ⇒ 值回到起点（防 tap-to-seek 在抬手瞬间才生效） */
      try { if (!s.h && String(s.el.value) !== String(s.v0)) s.el.value = s.v0; } catch (x) { }
      st = null;
    }, 60);
  }

  document.addEventListener('pointerdown', onDown, true);
  document.addEventListener('pointermove', onMove, true);
  document.addEventListener('input', onValue, true);
  document.addEventListener('change', onValue, true);
  document.addEventListener('pointerup', onUp, true);
  document.addEventListener('pointercancel', onUp, true);
  document.addEventListener('touchend', onUp, true);
  document.addEventListener('touchcancel', onUp, true);
})();
